<div id="content" class="main-content">
    <!-- ADD contact MESSAGES ############################################### -->
    <div class="col-xl-12 col-lg-12 mb-4 col-md-12 col-sm-12 alert alert-gradient alert-danger" 
       id="visit_terminated" role="alert" style="z-index: 100;position: absolute;display: none;right: 7%;
       position: absolute;background-image: linear-gradient(135deg,#30648fed 0,#009de6c4 100%) !important;"> 
       <i class="flaticon-cancel-12 close ml-3" data-dismiss="alert"></i> 
       <strong>La visite</strong> {{addedMsg}}
    </div>
    <div class="col-xl-12 col-lg-12 mb-4 col-md-12 col-sm-12 alert alert-gradient alert-danger" 
       id="visit_not_terminated" role="alert" style="z-index: 100;position: absolute;display: none;right: 7%;
       position: absolute;background-image: linear-gradient(135deg,#8f3030ed 0,#e60000c4 100%) !important;"> 
       <i class="flaticon-cancel-12 close ml-3" data-dismiss="alert"></i> 
       <strong>Erreur Technique</strong> Veuillez réessayer !
    </div>
     <div class="container">
        <div class="col-12 pl-0">
           <div class="crumbs breadcrumbs-style-2">
              <ul class="breadcrumb">
                 <li class="mt-3"><a routerLink="/mydash"><i class="flaticon-home-fill"></i></a>
                 </li>
                 <li class="active mt-3 current_arian"><a href="javascript:void(0);" class="current_arian">Terminer visite</a></li>
              </ul>
           </div>
        </div>
       <div class="page-header">
          <div class="page-title mt-3 row col-lg-12 col-md-12">
             <h2 *ngIf="toComplete" style="color:black">Êtes-vous sûr de vouloir terminer la visite <b>{{detail?.visit_code || ''}}</b> ?</h2>
             <h2 *ngIf="!toComplete"  style="color:black">Modification Rapport de la visite <b>{{detail?.visit_code || ''}}</b> ?</h2>
          </div>
       </div>
       <form class="form-login" [formGroup]="terminatedVisitForm"  novalidate>
          <div class="layout-spacing">
            <div *ngIf="terminer_plan" class="cp-spinner cp-bubble  loading-spinner">
            </div>
             <div class="page-container01">
                <div class="page-container02">
                   <h3 class="page-text">
                      <span>Détail visite</span>
                      <br />
                   </h3>
                   <div class="page-container03">
                    <div class="page-container04">
                      <div class="page-container05">
                        <div class="page-container06">
                          <h4 class="page-text03">Client</h4>
                          <div class="page-container07">
                            <span class="page-text04">{{detail?.visit_customer || '- - -'}}</span>
                          </div>
                        </div>
                        <div class="page-container08">
                          <h4 class="page-text05">Secteur</h4>
                          <div class="page-container09">
                            <span class="page-text06">{{detail?.customer_sector || '- - -'}}</span>
                          </div>
                        </div>
                      </div>
                      <div class="page-container10">
                        <div class="page-container11">
                          <h4 class="page-text07">Adresse & Ville</h4>
                          <div class="page-container12">
                            <span class="page-text08">{{detail?.visit_city_address || '- - -'}}</span>
                          </div>
                        </div>
                        <div class="page-container13">
                          <h4 class="page-text09">Visit topic</h4>
                          <div class="page-container14">
                            <span class="page-text10">{{detail?.visit_topic || '- - -'}}</span>
                          </div>
                        </div>
                      </div>                        
                    </div>
                    <div class="page-container15">
                      <div class="page-container16">
                        <div class="page-container17">
                          <h4 class="page-text11">Description</h4>
                          <div class="page-container18">
                            <span class="page-text12">{{detail?.visit_goal || '- - -'}}</span>
                          </div>
                        </div>
                        <div class="page-container19">
                        </div>
                      </div>
                      <div class="page-container21">
                      </div>
                    </div>
                  </div>
                </div>
             </div>
 
             <div class="page-container01">
                <div class="page-container02">
                   <h3 class="page-text">
                      <span>Actions</span>
                      <br />
                   </h3>
                   <div class="page-container03">
 
                      <div class="page-container04 action-container">
                        <div class="media table-responsive mx-4">
                            <table id="actions_ofvisit" class="table table-striped table-bordered table-wrapper" style="width:100%">
                                <thead>
                                    <tr>
                                        <th>Action</th>
                                        <th>Commentaire</th>   
                                        <th>Statut</th> 
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let action of perso; let i = index">
                                        <td>
                                            <span>{{action.action_desc || '- - -'}}</span>
                                        </td>
                                        <td>
                                            <textarea class="form-control pl-3 pr-3" rows="2" [value]="action.action_comment" placeholder="Saisir un commentaire" id="{{action.action}}" (keydown)="verifylenght($event)"></textarea>
                                            <span style="float: right;font-size: x-small;color: darkgray;" id="lenght-{{action.action}}"></span>
                                        </td>  
                                        <td>
                                            <div class="form-group text-left">
                                                <div>
                                                    <input id="{{action.action}}-non-fait" type="radio" name="status-{{action.action}}"
                                                           [checked]="action.status === 'Non fait'" (change)="updateStatus(action, 'Non fait')" value="Non fait">
                                                    <label for="{{action.action}}-non-fait" class="ml-2"> Non fait</label>
                                                </div>
                                                <div>
                                                    <input id="{{action.action}}-en-cours" type="radio" name="status-{{action.action}}"
                                                           [checked]="action.status === 'En cours'" (change)="updateStatus(action, 'En cours')" value="En cours">
                                                    <label for="{{action.action}}-en-cours" class="ml-2"> En cours</label>
                                                </div>
                                                <div>
                                                    <input id="{{action.action}}-fait" type="radio" name="status-{{action.action}}"
                                                           [checked]="action.status === 'Fait'" (change)="updateStatus(action, 'Fait')" value="Fait">
                                                    <label for="{{action.action}}-fait" class="ml-2"> Fait</label>
                                                </div>
                                                <button class="btn btn-danger btn-rounded mt-0 mb-0 pt-1 pb-1" *ngIf="action.new" (click)="removeAddedAction(action.action, perso)">Supprimer</button>
                                            </div>                                            
                                        </td>
                                    </tr>
                                    
                                    <tr class="row_new_action" style="background-color: #d4f6ff;">
                                        <td>
                                            <div class="form-group text-left" style="margin-top: -65px;">
                                                <label class="col-lg-4 col-md-6 col-sm-12 mt-2 h6 text-primary text-left" style="white-space: nowrap ;font-size: 14px;" >Action</label>
                                                <input type="text" class="form-control" placeholder="Saisir nouvelle action" name="action" id="new_action">
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-group text-left" style="margin-top: -40px;">
                                                <label class="col-lg-4 col-md-6 col-sm-12 mt-2 h6 text-primary text-left" style="white-space: nowrap ;font-size: 14px;" >Commentaire </label>
                                                <textarea class="form-control pl-3 pr-3"  rows="2" name="comment"placeholder="Saisir un commentaire" (keydown)="verifylenghtNewComment($event)" id="new_comment"></textarea>
                                                <span style="float: right;font-size: x-small;color: darkgray;" id="lenght-newComment"></span>
                                            </div>
                                        </td>  
                                        <td>
                                            <div class="form-group text-left">
                                                <div>
                                                    <input id="nonFait" type="radio" value="Non fait" checked name="statusAction">
                                                    <label for="nonFait" class="ml-2">Non fait</label>
                                                </div>
                                                <div>
                                                    <input id="enCours" type="radio" value="En cours" name="statusAction" >
                                                    <label for="enCours" class="ml-2">En cours</label>
                                                </div>
                                                <div>
                                                    <input id="fait" type="radio" value="Fait" name="statusAction">
                                                    <label for="fait" class="ml-2">Fait</label>
                                                </div>
                                                <button class="btn btn-primary btn-rounded mt-0 mb-0 pt-1 pb-1" (click)="addNewAction()">Ajouter</button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                      </div>
                   </div>   
                </div>
             </div>
 
             <div class="page-container01">
                <div class="page-container02">
                   <h3 class="page-text">
                      <span>Personnes contactées</span>
                      <br />
                   </h3>
                   <div class="page-container03">
    
                            <div class="w-100" [formGroup]="terminatedVisitForm">
                                <div class="p-3 border-white rounded bg-gray mx-4 mb-4" style="background-color: #f5f5f5;">
                                    <div class="page-container04">
                                        <div class="page-container05"  style="flex-direction: column;">
                                            <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                                                <input type="text" class="form-control  mdl-textfield__input form-control-rounded" 
                                                 aria-label="default"  id="input"
                                                name="contact_fullname" formControlName="contact_fullname" [ngClass]="{'is-invalid':terminatedVisitForm.get('contact_fullname')?.touched
                                                && terminatedVisitForm.get('contact_fullname')?.invalid}"> 	
                                                <label class="mdl-textfield__label h6">Nom complet <span style="color: red;">*</span></label>
                                            </div>
                                            <div *ngIf="terminatedVisitForm.get('contact_fullname')?.touched && terminatedVisitForm.get('contact_fullname')?.errors?.required" class="invalid-feedback"> 
                                                Ce champ est obligatoire
                                            </div>  
                                            <div *ngIf="terminatedVisitForm.get('contact_fullname')?.touched && terminatedVisitForm.get('contact_fullname')?.errors?.minlength" class="invalid-feedback">
                                                Le nom complet doit contenir au moins 5 caractères.
                                            </div>
                                            <div *ngIf="terminatedVisitForm.get('contact_fullname')?.touched && terminatedVisitForm.get('contact_fullname')?.errors?.invalidCharacters" class="invalid-feedback">
                                                Le nom complet ne peut contenir que des lettres.
                                            </div>                                            
                                        </div>
                                        <div class="page-container10" style="flex-direction: column;">
                                            <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                                                <input type="text" class="form-control  mdl-textfield__input form-control-rounded" name="contact_function" formControlName="contact_function"> 	
                                                <label class="mdl-textfield__label h6">Fonction</label>     
                                            </div>
                                        </div>
                                    </div>
                                    <div class="page-container15">
                                        <div class="page-container16" style="flex-direction: column;">
                                            <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label" >
                                                <input type="tel" class="form-control  mdl-textfield__input form-control-rounded" name="contact_phone" formControlName="contact_phone"> 	
                                                <label class="mdl-textfield__label h6">Nº Téléphone</label>    	 
                                            </div>
                                            <div style="margin-left: auto;" *ngIf="terminatedVisitForm.get('contact_phone')?.errors?.pattern"  class="invalid-feedback"> 
                                                Numéru de Téléphone invalid
                                            </div>
                                        </div>
                                        <div class="page-container21" style="flex-direction: column;">
                                            <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                                                <input type="email" class="form-control  mdl-textfield__input form-control-rounded" name="contact_email" formControlName="contact_email"> 	
                                                <label class="mdl-textfield__label h6">Email</label>     
                                            </div>    
                                            <div style="margin-left: auto;" *ngIf="terminatedVisitForm.get('contact_email')?.errors?.email"  class="invalid-feedback"> 
                                                Adresse mail invalid
                                            </div>                                        
                                        </div>
                                     </div>
                                    <div class="mt-0 text-right col-lg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <button class="btn btn-primary btn-rounded mt-0 mb-0 pt-1 pb-1" (click)="addDetailToFinish()" 
                                            [disabled]="!terminatedVisitForm.valid">Ajouter</button>
                                    </div>
                                    <div class="d-flex justify-content-center">
                                        <div class="col-xl-12 col-lg-12 mb-4 col-md-12 col-sm-12 alert alert-gradient alert-danger alert-survey" 
                                        id="visit_terminated" role="alert"  [style.display]="isContactSelected ? 'block' : 'none'"> 
                                        <i class="flaticon-cancel-12 close ml-3" data-dismiss="alert"></i> 
                                        <strong>Le contact</strong> que vous avez sélectionner recevra une enquête de satisfaction par mail
                                    </div>
                                    </div>
                                    <div class="media table-responsive mt-3" *ngIf="sells.length !=0">
                                        <table class="table table-striped table-bordered">
                                            <thead style="background-color: #cac0ff6b;">
                                                <tr>
                                                    <th>Nom complet</th>
                                                    <th>Fonction</th>
                                                    <th>Nº Téléphone</th>
                                                    <th>Email</th>  
                                                    <th></th> 
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let prod of sells" >
                                                    <td>
                                                        <span *ngIf="prod.contact_email && config.survey">
                                                            <input type="radio" name="sendTo" id="sendTo{{prod.contact_email}}"  [(ngModel)]="selectedContact" [value]="prod.contact_email" 
                                                            title="Le contact que vous avez sélectionner recevra une enquête de satisfaction par mail"  [ngModelOptions]="{standalone: true}"
                                                            (change)="onContactSelected()">
                                                        </span>
                                                        {{prod.contact_fullname || '- - -'}}
                                                    </td>
                                                    <td> 
                                                        {{prod.contact_function || '- - -'}}
                                                    </td>
                                                    <td>
                                                        {{prod.contact_phone || '- - -'}}
                                                    </td>
                                                    <td>{{prod.contact_email || '- - -'}}</td>
                                                    <td>
                                                        <button type="button" class="btn btn-dark mr-2" (click)="removeDetailToFinish(prod)">
                                                            <i class="flaticon-delete text-white" style="background-color: unset;"></i></button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                   </div>
                </div>
             </div>
 
             <div class="page-container01">
                <div class="page-container02">
                   <h3 class="page-text">
                      <span>Pièce jointe</span>
                      <br />
                   </h3>
                   <div class="page-container03">
                      <div class="page-container60">
                         <div class="page-container61">
                            <div class="page-container62 mb-5">
                                <div class="custom-file-container w-100" data-upload-id="myFirstImage">
                                    <p class="mb-0"><i class="flaticon-picture text-default mr-2" style="background-color: unset;"></i>Joindre des photos</p>
                                    <label class="custom-file-container__custom-file" >
                                        <input type="file" class="custom-file-container__custom-file__custom-file-input upload__inputfile" accept="image/*" multiple=""
                                            data-max_length="20" (change)="addPic($event)">
                                        <input type="hidden" name="MAX_FILE_SIZE" value="10485760" />
                                        <span class="custom-file-container__custom-file__custom-file-control"></span>
                                    </label>
                                    <div class="upload__img-wrap"></div>
                                </div>
                            </div>
                         </div>
                       </div>                        
                   </div>
                </div>
             </div>
             
             <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 col-12 layout-spacing mt-3">
                <div class="l-a-load-more pt-2 actions_buttons d-flex justify-content-center">
                   <button class="btn progress-button btn-rounded mb-2 pr-5 pl-5 mr-2" style="background-color: #bac5ed;" (click)="stepBack()">
                      Retour
                   </button>
                   <button id="loading-circle-notification" class="btn btn-gradient-dark btn-rounded mb-2 mr-2 pr-5 pl-5"(click)="terminateVisit('save')">
                        Enregistrer comme brouillon
                    </button>
                    <button class="btn btn-gradient-success btn-rounded mb-2 pr-5 pl-5 mr-2"(click)="terminateVisit('finish')" [disabled]="sells.length == 0">
                        Terminer la visite
                    </button>
                </div>
             </div>
          </div>
       </form>
     </div>
  </div>